import { useMemo } from 'react'

import { useI18n } from '@tribeplatform/react-components/i18n'

import { SpaceHeaderProps } from '../types.js'
import { SpaceHeader } from './SpaceHeader.js'
import { getEmbedProps } from './utils.js'

interface Props {
  spaceId: string
}

export const EmbeddedSpaceHeader = ({ spaceId }: Props) => {
  const intl = useI18n()
  const props: SpaceHeaderProps = useMemo(
    () => ({
      ...getEmbedProps(intl),
      spaceId,
    }),
    [intl, spaceId],
  )

  return (
    <div className="@container">
      <SpaceHeader {...props} />
    </div>
  )
}
